const moment = require('moment')
const Holidays = require('date-holidays')
const hd = new Holidays('CZ')


function mutateMarktime(marktime) {

    marktime.marktime =  marktime.marktime.map(day => {

        day.timeFrom = (day.timeFrom) ? new Date(day.timeFrom.seconds * 1000) : null
        day.timeTo = (day.timeTo) ? new Date(day.timeTo.seconds * 1000) : null

        return day
    })

    return marktime
}


function canAccess(type, user) {
    if (user) {
        if (user.role === 'superadmin' || user[type]) return true
    }
    return false
}

function getVacMonthTotal(marktime) {

    if (!marktime) return ''

    var days = 0;

    marktime.marktime.forEach(day => {
        if (day.type === 'D') {
            if (day.halfday) days += 0.5
            else days += 1
        }
    })

    if (days) return days
    return ''
}


function getOvtMonthTotal(marktime) {

    if (!marktime) return ''

    var overtime = 0;

    marktime.marktime.forEach((day) => {
        if (day.overtime) overtime += parseFloat(day.overtime)
    })

    if (overtime) return overtime
    return ''

}

function getDuration(marktime) {

    if (!marktime.timeFrom) return 0;

    var timeFrom = moment(marktime.timeFrom)
    var timeTo = moment(marktime.timeTo)

    var diff = moment.duration(timeTo.diff(timeFrom)).asHours()

    if (diff > 4) {
        timeTo = moment(marktime.timeTo).add(-30, 'minutes')
    }

    return moment.duration(timeTo.diff(timeFrom)).asHours()

}


const isHoliday = date => {

    var holiday = hd.isHoliday(date)

    if (holiday) {
        if (holiday.type === 'public') return true
    }

    return false

}

const isSunday = date => {
    return date.getDay() == 0;
}

const isSaturday = date => {
    return date.getDay() == 6;
}


export default {
    mutateMarktime,
    canAccess,
    getVacMonthTotal,
    getOvtMonthTotal,
    getDuration,
    isHoliday,
    isSunday,
    isSaturday
}